module.exports = __webpack_public_path__ + "img/Doctor.3d498c8.png";